import React, { Component } from "react";

// Components
import { TimestampToDate } from "@utils/date.js";
import { twoDecimal } from "@utils/format";

import "./table.css";

class Page extends Component {
  componentDidMount() {
    if (typeof this.props.handleDidMount == "function") {
      this.props.handleDidMount();
    }
  }

  render() {
    const { table, date, posto, serie, tpv, cliente, search, tipo, provider } = this.props;

    // Verificar se há recibos de fornecedores nos resultados
    const hasProviderPayments = table.rows.some(p => p.tipo === 'recibo_fornecedor');
    // Verificar se há JSCM nos resultados
    const hasJSCMPayments = table.rows.some(p => p.tipo === 'JSCM');

    // Lógica de visibilidade:
    // Se não há fornecedores OU tipo JSCM selecionado -> esconder filtro/colunas de fornecedores
    const hideProviderFields = !hasProviderPayments || tipo?.value === "JSCM";
    // Se não há JSCM OU tipo recibo_fornecedor selecionado -> esconder filtros/colunas de JSCM
    const hideJSCMFields = !hasJSCMPayments || tipo?.value === "recibo_fornecedor";

    const hasJSCM = !hideJSCMFields;
    const hasProvider = !hideProviderFields;
    const totalCols = table.columns.filter(col => {
      // Aplicar mesma lógica de filtragem de colunas
      if (hideProviderFields) {
        if (['tipo', 'fornecedor', 'observacoes'].includes(col.id)) {
          return false;
        }
      }
      if (hideJSCMFields) {
        if (['tipo', 'posto', 'tpv', 'turno', 'cod_raspadinha', 'nome_raspadinha'].includes(col.id)) {
          return false;
        }
      }
      return true;
    }).length;
    
    return (
      <table style={{ width: "100%" }}>
        <tr>
          <th colSpan={totalCols}>
            <table style={{ width: "100%", borderBottom: '1px solid black' }}>
              <tr>
                <th>Data Inicial</th>
                <th>Data Final</th>
                {!hideJSCMFields && <th>Posto</th>}
                {!hideJSCMFields && <th>TPV</th>}
                {!hideProviderFields && <th>Fornecedor</th>}
                {!hideProviderFields && !hideJSCMFields && <th>Tipo</th>}
              </tr>
              <tr>
                <td>{TimestampToDate(date[0] / 1000).split(" ")[0]}</td>
                <td>{TimestampToDate(date[1] / 1000).split(" ")[0]}</td>
                {!hideJSCMFields && <td>{posto?.label || 'TODOS'}</td>}
                {!hideJSCMFields && <td>{tpv?.label || 'TODOS'}</td>}
                {!hideProviderFields && <td>{provider?.label || 'TODOS'}</td>}
                {!hideProviderFields && !hideJSCMFields && <td>{tipo?.label || 'TODOS'}</td>}
              </tr>
            </table>
          </th>
        </tr>
        <tr>
          <th colSpan={totalCols - 1}>&nbsp;</th>
          <th style={{ border: "1px solid black", borderBottom: 0 }}>Total</th>
        </tr>
        <tr>
          <td colSpan={totalCols - 1}>&nbsp;</td>
          <td style={{ border: "1px solid black", borderTop: 0 }}>
            {twoDecimal(table.rows.reduce((acc, row) => {
              const valor = parseFloat(row.valor || row.valor_liquido || 0);
              return acc + valor;
            }, 0))}
          </td>
        </tr>
        <tr>
          {table.columns
            .filter(({ id, accessor }) => {
              // Aplicar mesma lógica de filtragem de colunas
              if (hideProviderFields) {
                if (['tipo', 'fornecedor', 'observacoes'].includes(id)) {
                  return false;
                }
              }
              if (hideJSCMFields) {
                if (['tipo', 'posto', 'tpv', 'turno', 'cod_raspadinha', 'nome_raspadinha'].includes(id)) {
                  return false;
                }
              }
              return id !== 'registo';
            })
            .map(({ Header }) => (
              <th key={Header}>{Header}</th>
            ))}
        </tr>
        {table.rows.map((row, index) => {
          const filteredColumns = table.columns.filter(({ id }) => {
            // Aplicar mesma lógica de filtragem de colunas
            if (hideProviderFields) {
              if (['tipo', 'fornecedor', 'observacoes'].includes(id)) {
                return false;
              }
            }
            if (hideJSCMFields) {
              if (['tipo', 'posto', 'tpv', 'turno', 'cod_raspadinha', 'nome_raspadinha'].includes(id)) {
                return false;
              }
            }
            return id !== 'registo';
          });

          return (
            <tr key={index}>
              {filteredColumns.map(({ id, accessor, Header }) => {
                let value;
                if (typeof accessor === 'function') {
                  value = accessor(row);
                } else if (typeof accessor === 'string') {
                  const keys = accessor.split('.');
                  value = keys.reduce((obj, k) => obj && obj[k], row);
                } else {
                  value = row[id];
                }

                // Formatação especial para valor
                if (id === 'valor') {
                  value = twoDecimal(value || 0);
                }

                return <td key={id}>{value !== undefined && value !== null ? value : '-'}</td>;
              })}
            </tr>
          );
        })}
      </table>
    );
  }
}

export default Page;
